import React from "react";
import { dateFormat } from "../../../helper/dateConvertor";
import { numberNotation } from "../../../helper/numberStructure";
import { ImageInsurance } from "../../visa-insurance/ImageInsurance";
import "./CardInsurancePublic.scss";

const CardInsurancePublic = ({ insurance }) => {
  return (
    <div className="insurance-public-card">
      <div className="card__insurance--heading">
        <div className="card__insurance--img">
          <ImageInsurance provider={insurance.provider} />
        </div>
        <div>
          <h2 className="title-gray-bold-22">{insurance.provider}</h2>
          <h2 className="paragraph-gray-reg-20">{insurance.type}</h2>
        </div>
      </div>
      <div className="content-info">
        <span className="paragraph-gray-reg-20">Start</span>
        <span className="paragraph-gray-bold-20">
          {dateFormat(insurance.startDate)}
        </span>
      </div>
      <div className="content-info">
        <span className="paragraph-gray-reg-20">End</span>
        <span className="paragraph-gray-bold-20">
          {dateFormat(insurance.endDate)}
        </span>
      </div>
      {/* <div className="content-info">
        <span className="paragraph-gray-reg-20">Duration</span>
        <span className="paragraph-gray-bold-20">{`calculate`} weeks</span>
      </div> */}
      <div className="content-info">
        <span className="paragraph-gray-reg-20">Price</span>
        <span className="paragraph-gray-bold-20">
          A$ {numberNotation(insurance.total)}
        </span>
      </div>
    </div>
  );
};

export default CardInsurancePublic;
